'use client';

import React__default, { useContext } from 'react';
import { ECalendarType, ECalendarStyle } from '../types.js';
import { ELanguage } from '../../Utils/constants.js';

var initCalendarState = {
    type: ECalendarType.month,
    langCode: ELanguage.EN,
    calendarStyle: ECalendarStyle.single,
    currentDate: new Date(),
    setCurrentDate: function () { },
    minDate: null,
    maxDate: null,
    selectedDates: null,
    setSelectedDates: function () { },
    handleDatesClick: function () { },
    year: 0,
    setYear: function () { },
    month: 0,
    setMonth: function () { },
    calendarType: ECalendarType.month,
    setCalendarType: function () { },
    temporaryDates: [],
    setTemporaryDates: function () { },
    rangeYears: [1900, new Date().getFullYear()]
};
var CalendarContext = React__default.createContext(initCalendarState);
var useCalendar = function () { return useContext(CalendarContext); };

export { CalendarContext, initCalendarState, useCalendar };
//# sourceMappingURL=calendar.js.map
